import { connect } from 'react-redux'
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { formatURL } from '../../../utils';
import { closeModalQuotationDateYear } from '../../../actions/searchActions';

export class ModalQuotationDateYear extends Component {
    constructor(props) {
        super(props)

        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        this.props.closeModalQuotationDateWarning()
        const location = {
            pathname: formatURL(
                this.props.match,
                `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
                null
            ),
        }
        this.props.history.replace(location);
    }

    render() {
        if (!this.props.isModalQuotationDateYearActive)
            return <div />

        return (
            <div className="comp_modalpagamento quotationDateWarning-modal">
                <div className="modalcontents modalyear">
                <div onClick={this.props.closeModalQuotationDateYear} className="close-btn" > &times; </div>
                    <div className="contents">
                        <div className="modalmiddle yearmodal">
                            <img src="/assets/images/calendar-year.svg" alt="Você está pesquisando um seguro viagem para hoje" className="icon-modal" />
                            <h3>Precisa de cobertura para mais <br/> de um ano? <span>Nós te ajudamos!</span></h3>

                            <p className="text-middle">
                              Nossa equipe vai te auxiliar a escolher o melhor plano com a duração necessária. Entre em contato com a gente em um dos <a rel="noopener noreferrer" target="_blank" href="https://segurospromo.com.br/atendimento"> nossos canais de atendimento</a>.
                            </p>

                            <ul className="list-contact">
                                <li>
                                    <strong>WhatsApp</strong>
                                    <div>
                                        <a href="https://api.whatsapp.com/send?phone=553139727083&text=Seguros%20Promo" target="_blank" rel="noopener noreferrer">
                                            (31) 3972-7083
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <strong>Atendimento</strong>
                                    <div>
                                        <a href="tel:(31) 4003-8442" target="_blank" rel="noopener noreferrer">
                                            (31) 4003-8442
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <strong>E-mail</strong>
                                    <div>
                                        <a href="mailto: atendimento@segurospromo.com.br" target="_blank" rel="noopener noreferrer">
                                            atendimento@segurospromo.com.br
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="choosecontainer">
                            <div className="optionone">
                                <a href="https://www.segurospromo.com.br">
                                 <button className="button" onClick={this.props.closeModalQuotationDateWarning}>
                                       <span>Voltar à pesquisa</span>
                                 </button>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        isModalQuotationDateYearActive: state.search.isModalQuotationDateYearActive
    }),
    {
      closeModalQuotationDateYear
    }
)(withRouter(ModalQuotationDateYear));



// WEBPACK FOOTER //
// ./src/components/common/modal_quotation_date_year/ModalQuotationDateYear.jsx